module.exports = __webpack_public_path__ + "img/sheep.6be03237.jpg";